import {
  DROP_PIN_MAP_HANDOFF_MS,
  waitForNextPaint,
  waitForTimeout,
} from './dropPinFallOverlay';

export const DROP_PIN_SOURCE_RESTORE_DELAY_MS = 50;

export type CompleteDropPinFallToMapPinOptions = {
  readonly dismissFall: (() => Promise<void>) | null;
  readonly revealMapPin: () => void;
  /** remount button */
  readonly whileCovered?: () => Promise<void>;
  readonly handoffHoldMs?: number;
};

export async function completeDropPinFallToMapPin(
  options: CompleteDropPinFallToMapPinOptions,
): Promise<void> {
  const {
    dismissFall,
    revealMapPin,
    whileCovered,
    handoffHoldMs = DROP_PIN_MAP_HANDOFF_MS,
  } = options;

  revealMapPin();
  await waitForNextPaint();
  await waitForTimeout(handoffHoldMs);

  if (whileCovered) {
    await whileCovered();
    await waitForNextPaint();
  }

  if (dismissFall) {
    await dismissFall();
  }
}

/** Restore the panel pin button in place after a brief delay. */
export function restoreDropPinSourceButton(
  release: () => void,
  delayMs: number = DROP_PIN_SOURCE_RESTORE_DELAY_MS,
): Promise<void> {
  if (typeof window === 'undefined' || delayMs <= 0) {
    release();
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    window.setTimeout(() => {
      release();
      resolve();
    }, delayMs);
  });
}
